import React from 'react';
import classNames from 'classnames';
import noop from 'lodash/noop';

import { OverlayWrapper } from 'features/Betslip/styled';
import '../styles/draggable-area.css';

const DraggableArea = ({
    children,
    shown,
    className,
    onOverlayClick = noop,
    styles,
}) => {
    const cls = classNames(
        'draggable-area',
        'draggable-area-animate',
        className,
        { 'draggable-area-animate-open': shown }
    );

    return (
        <OverlayWrapper showOverlay={shown} onClick={onOverlayClick}>
            <div
                className={cls}
                style={styles}
                onClick={(e) => e.stopPropagation()}
            >
                <hr className="draggable-area-delimiter" />
                {children}
            </div>
        </OverlayWrapper>
    );
};

export default DraggableArea;
